export const APK_EXTENSION_ERROR_MESSAGE =
  'Please select a file with a .apk extension.';

export function hasApkFileExtension(fileName: string): boolean {
  const normalized = fileName.trim().toLowerCase();
  return normalized.length > '.apk'.length && normalized.endsWith('.apk');
}
